import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CalendlyLogo } from './calendly_logo';
import { ToggleButton } from './elements';
import { CloseIcon, MenuIcon } from './icons';
import { leftNavigationSelector } from './selectors';
import { setOpen } from './slice';
const wrapperCss = "w1botpt2";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const DetachedNavigationTrigger = ({
  showExpanded = true
}) => {
  const dispatch = useDispatch();
  const isPhone = useDeviceType('isPhone');
  const {
    open
  } = useSelector(leftNavigationSelector);
  if (!isPhone) return null;
  return <Wrapper>
      <ToggleButton aria-label={open ? I18n.t('publisher.left_navigation.collapse') : I18n.t('publisher.left_navigation.expand')} data-calendly-label="mobile-menu-button" onClick={() => dispatch(setOpen(!open))}>
        {open ? <CloseIcon /> : <MenuIcon />}
      </ToggleButton>
      <CalendlyLogo minimized={!open || !showExpanded} isPhone />
    </Wrapper>;
};

require("./detached_navigation_trigger.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./detached_navigation_trigger.js");